import { Control, UseFormSetValue, Controller } from 'react-hook-form';
import { CreateRecyclingConsignmentOrderV2SchemaType } from '../../common';
import { FormLabel } from '../../form-label';
import LOCALS from 'commons/locals';
import i18n from 'i18n';
import { Select } from 'antd';
import { useAppSelector } from 'store/hooks';
import { selectGlobalInfo } from 'store/slices/globalInfoSlice';
import { useCallback } from 'react';
import { SelectOption } from 'types/base';

const Color = ({
  control,
  index,
  setValue,
  required,
}: {
  control: Control<CreateRecyclingConsignmentOrderV2SchemaType>;
  index: number;
  setValue: UseFormSetValue<CreateRecyclingConsignmentOrderV2SchemaType>;
  required?: boolean;
}) => {
  const { colorSelectOptions } = useAppSelector(selectGlobalInfo);
  const SelectFilter = useCallback(
    (input: string, option: SelectOption | undefined) =>
      (option?.label ?? '').toLowerCase().includes(input.toLowerCase()),
    []
  );

  return (
    <div className="flex items-center gap-2">
      <FormLabel required={required}>{i18n.t(LOCALS.color)}:</FormLabel>
      <Controller
        name={`productList.${index}.color`}
        control={control}
        render={({ field, formState: { errors } }) => (
          <Select
            {...field}
            className="w-full"
            mode="multiple"
            showSearch
            status={errors.productList?.[index]?.color ? 'error' : undefined}
            options={colorSelectOptions}
            filterOption={SelectFilter}
            placeholder={i18n.t(LOCALS.please_select)}
            onChange={(value) => {
              field.onChange(value);

              if (value && value.length > 1) {
                setValue(`productList.${index}.colors`, 'multi-color');
              }

              if (value && value.length === 1) {
                const color = colorSelectOptions.find(
                  (d) => d.value === value[0]
                );
                if (color && (color.refProperty1 || color.refProperty2)) {
                  setValue(
                    `productList.${index}.colors`,
                    color.refProperty1 || color.refProperty2 || ''
                  );
                }
              }

              if (!value || value.length === 0) {
                setValue(`productList.${index}.colors`, '');
              }
            }}
          />
        )}
      />
    </div>
  );
};

export default Color;
